import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import PublicSite from "@/pages/PublicSite";
import AdminPanel from "@/pages/AdminPanel";
import { Toaster } from "@/components/ui/toaster";
import { ContentProvider, useContent } from "@/hooks/useContent";

function AppRoutes() {
  const { content } = useContent();
  const adminSlug = (content && content._meta && content._meta.adminRoute) || "9374205";

  return (
    <Routes>
      {/* Admin Panel - secret URL, no Navbar/Footer */}
      <Route path={`/${adminSlug}`} element={<AdminPanel />} />

      {/* Public site */}
      <Route path="/*" element={<PublicSite />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <ContentProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </ContentProvider>
      <Toaster />
    </div>
  );
}
